'use strict';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

/**
 * @typedef {Object} UpdateModalReducerOptions
 */

/**
 * @param {ReactReduxModal} reactReduxModal
 * @param {UpdateModalActions} actions
 * @param {UpdateModalReducerOptions} options
 * @return {{reducer: Function, initialState: Object}}
 */
export function buildReducer(reactReduxModal, actions, options) {
  const originalReducer = reactReduxModal.reducers.reducer;

  // Validate options
  if (!isObject(actions) || !isObject(actions.sendRequest) || !isString(actions.sendRequest.TYPE))
    throw new Error('update-modal/buildReducer missing required actions');

  const initialState = {
    isFetching: false,
    showSuccess: false,
    err: null,
    ...reactReduxModal.reducers.initialState,
  };

  return {
    initialState,
    reducer,
  };

  function reducer(state = initialState, action) {
    switch (action.type) {
      case actions.sendRequest.TYPE:
        return {
          ...state,
          isFetching: true,
          showSuccess: false,
          err: null,
        };
      case actions.requestSuccess.TYPE:
        return {
          ...state,
          isFetching: false,
          showSuccess: true,
          err: null,
        };
      case actions.requestError.TYPE:
        return {
          ...state,
          isFetching: false,
          err: action.payload.err,
        };

      // Boilerplate:
      case actions.hideModal.TYPE:
        return initialState;
      default:
        return originalReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux/update-modal/buildReducer.js